import classEvaluaion from './classEvaluation'
import teacherEvaluation from './teacherEvaluation'
const comprehensiveEvaluation = {
  path: 'comprehensiveEvaluation/:myClassId',
  component: resolve => require(['../../../../components/pages/student_user/comprehensiveEvaluation'], resolve),
  redirect: 'comprehensiveEvaluation/:myClassId/classEvaluation/:myClassId',
  props: true,
  children: [
    classEvaluaion,
    teacherEvaluation
  ]
}
export default comprehensiveEvaluation



// WEBPACK FOOTER //
// ./src/router/pages/student_user/comprehensiveEvaluation/index.js